<template>

    <bottom-sheet ref="bottomsheet" :selfClose="true">

        <div class="bsms">

            <div v-if="showErrorAtLeast" class="at-least">
                <img src="/img/icons/info-white.svg" class="img__20 mr__8">
                <span class="text-baseRegular color__white">{{ $t('select_one_email') }}</span>
            </div>

            <div v-else class="bsms__container">

                <img src="/img/navigation/mailbox-empty.svg" class="img__40 mt__8">

                <p class="text-lSemibold mt__8">{{ $tc('mailbox_to_clean', mailboxes.length) }}</p>

            </div>

            <div class="divider"></div>

            <div class="bsms__container">

                <button class="text-lSemibold color__aquamarine bsms__select-all mt__16"
                        v-show="mailboxes.length > 1"
                        @click="selectAll">
                    {{ $t('cleaning_select_all_inbox') }}
                </button>

                <div class="bsms__mailboxes">

                    <div class="bsms__mailbox" v-for="mailbox in mailboxes"
                         @click="toggleEmail(mailbox)">
                        <div class="bsms__mailbox__left">
                            <div class="shutdown-provider" v-if="Mailboxes.isInvalidMailbox(mailbox)"><img
                                class="img__24"
                                src="/img/icons/alert-white.svg">
                            </div>
                            <img v-else :src="getProviderImg(mailbox.provider)" class="img__40">
                        </div>
                        <div class="bsms__mailbox__middle">
                            <p class="text-baseSemibold ellipsis-text"
                               :class="{'shutdown': Mailboxes.isInvalidMailbox(mailbox), 'color__moon': !mailbox.isActive}">
                                {{ mailbox.email }}</p>
                            <p class="text-sSemibold" :class="{
                                'color__stone': !mailbox.isActive,
                                  'color__raspberry': Mailboxes.isInvalidMailbox(mailbox)}">
                                {{ mailboxInfos(mailbox) }}
                            </p>
                        </div>
                        <div class="bsms__mailbox__right">
                            <lottie-loader :size="24"
                                           v-if="isActiveMailboxesUpdating.indexOf(mailbox.email) > -1"></lottie-loader>
                            <button v-else-if="Mailboxes.isInvalidGrant(mailbox)"
                                    class="reconnect text-baseSemibold color__aquamarine" @click="reconnect(mailbox)">
                                {{ $t('reconnect') }}
                            </button>
                            <img v-else-if="!Mailboxes.isProviderShutdown(mailbox)"
                                 :src="Mailboxes.mailboxStatusIcon(mailbox)" class="img__24">
                        </div>
                    </div>

                </div>

                <button class="ds__button__medium ds__button__fluid ds__button__secondary text-lSemibold mt__16"
                        @click="validate">{{ $t('cleaning_validate_email_selec') }}
                </button>
                <p class="ds__link__default ds__link__fluid text-lSemibold mt__16" @click="goAddInbox">
                    {{ $t('cleaning_done_add_mailbox_cta') }}</p>

            </div>

        </div>

        <toast ref="toast"></toast>

    </bottom-sheet>

</template>

<script>
import Vuex from 'vuex'

import Auth from '../../modules/auth'
import Mailboxes from '../../modules/mailboxes'
import Tag from '../../modules/tag'

import BottomSheet from '../../components/bottomSheet/BottomSheet'
import LottieLoader from '../../components/lottie/LottieLoader'
import Toast from '../../components/Toast'

export default {

    name: 'bottom-sheet-mailboxes-selection',

    components: {
        BottomSheet,
        LottieLoader,
        Toast
    },

    watch: {
        $mq: function (newValue) {
            if (newValue === 'lg') {
                this.close()
            }
        }
    },

    data() {
        return {
            showErrorAtLeast: false
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'isActiveMailboxesUpdating',
            'mailboxes'
        ]),

        Mailboxes() {
            return Mailboxes
        }
    },

    methods: {

        ...Vuex.mapActions([
            'updateIsActiveMailbox'
        ]),

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
        },

        getProviderImg(provider) {
            switch (provider) {
                case 'google':
                    return '/img/providers/circle-google.png'
                case 'icloud':
                    return '/img/providers/circle-icloud.png'
                case 'microsoft':
                    return '/img/providers/circle-microsoft.png'
                case 'orange':
                    return '/img/providers/circle-orange.png'
                case 'yahoo':
                    return '/img/providers/circle-yahoo.png'
                default:
                    return '/img/providers/circle-imap.png'
            }
        },

        toggleEmail(mailbox) {
            if (Mailboxes.isLastActiveEmail(mailbox)) {
                this.atLeastOneError()
            } else if (Mailboxes.itCanBeDisabled(mailbox)) {
                Tag.clickGA(this, 'select_mailbox')
                this.updateIsActiveMailbox({email: mailbox.email, bool: !mailbox.isActive})
                    .catch(error => {
                        if (error && error.message === 'minimum_active_account') {
                            this.$refs.toast.open(this.$t('settings_error'))
                        } else {
                            this.$refs.toast.open()
                        }
                    })
            }
        },

        selectAll() {
            Tag.clickGA(this, 'select_all')
            const toUpdateMailboxes = this.mailboxes.filter(mailbox => !mailbox.isActive).map(mailbox => mailbox.email)
            toUpdateMailboxes.map(email => this.toggleEmail(email, true))
        },

        validate() {
            Tag.clickGA(this, 'validate')
            this.close()
        },

        goAddInbox() {
            Tag.clickGA(this, 'add_mailbox')
            this.$router.push({path: '/add-inbox'})
        },

        mailboxInfos(mailbox) {
            if (Mailboxes.isInvalidGrant(mailbox)) {
                return this.$t('account_disconected')
            }
            if (Mailboxes.isProviderShutdown(mailbox)) {
                return this.$t('sorting_unavailable')
            }
            return this.$tc('cleaning_nb_mails_to_sort', mailbox.count, {'nb_emails': mailbox.count})
        },

        atLeastOneError() {
            this.showErrorAtLeast = true
            setTimeout(() => {
                this.showErrorAtLeast = false
            }, 3000)
        },

        reconnect(mailbox) {
            Auth.reconnect(this, mailbox)
        }
    }

}

</script>

<style lang="scss" scoped>

.bsms {
    display: flex;
    flex-direction: column;
    width: 100%;

    &__container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0 16px 16px;
    }

    &__select-all {
        text-decoration: underline;
        background-color: $white;
    }

    &__mailboxes {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 16px 0;
    }

    &__mailbox {
        margin-top: 12px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        &__left {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__middle {
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            align-items: baseline;
            flex: 1;
            overflow: hidden;

            > p {
                width: 100%;
                text-align: start;

                &:lang(ar-sa) {
                    text-align: right;
                }
            }
        }

        &__right {
            display: flex;
            align-items: center;
            justify-content: center;

            .reconnect {
                background-color: inherit;
            }
        }
    }

    .at-least {
        //width: 100%;
        margin: 0 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 16px;
        border-radius: 12px;
        background: $midnight;
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.10), 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
        text-align: start;
    }
}

.divider {
    height: 1px;
    width: 100%;
    background-color: $silver;
}

.shutdown-provider {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $raspberry;
    border-radius: 40px;
}

.shutdown {
    color: $stone;
}

</style>
